<template>
  <div>
    <!-- 1 -->
    <section class="main">
      <div class="d-flex flex-column flex-md-row mb-5">
        <div
          class="col-12 col-md-5 d-flex flex-column justify-content-center align-items-start p-3"
        >
          <h1 class="f-secondary t-secondary text-gradient p-2">
            Something transformative is on the horizon
          </h1>
          <div class="f-primary p-2 line-height-30 mb-3 text-justify">
            TalentFind is preparing to unveil a major international partnership that’s set to redefine the future of global healthcare workforce development.Stay tuned—<b>an exciting announcement is due this month.</b>
            Innovation, impact, and international collaboration are about to take centre stage.
          </div>
        </div>
        <div class="col-12 col-md-7 p-0">
          <img src="../../../public/img/stm/job-banner.png" class="img-fluid" />
        </div>
      </div>
    </section>

    <!-- 2 -->
    <section class="main container-fluid">
      <div
        class="d-flex justify-content-center align-items-center flex-column mb-3"
      ></div>
      <!-- Starts -->
      <div class="row my-5">
        <!-- Left -->
        <div class="col-md-6 text-start order-md-1">
          <div>
            <h2 class="f-secondary text-gradient-2 font-40 mb-3">
              Welcome to the TalentFind Knowledge & News Hub
            </h2>
            <h5 class="text-second text-uppercase mb-3">Your gateway to global health workforce intelligence</h5>
            <p class="w-80 text-justify">
              The <b>Knowledge & News Hub</b> is a dynamic digital platform built to empower healthcare professionals, educators, organisations, governments and regulatory bodies worldwide. Its mission is clear: to create a centralized space for sharing expert insights, publishing thought-led articles and cutting-edge white papers – promoting meaningful dialogue in one place. Connect with speciality-specific communities and access resources that will help shape the future of ethical global health and care workforce development. Stay tuned – exciting content and community features are on the way!
            </p>
          </div>
        </div>

        <!-- Right -->
        <div class="col-md-6 text-center order-md-2 mb-5 mb-md-0">
          <img
            class="img-fluid border-radius-40"
            src="../../../public/img/stm/work5.png"
            alt="Image Description"
          />
        </div>
      </div>
      <!-- Ends -->
    </section>
    <!-- 3 -->
    <EnquirySection />
    <NewFooter />
    <ScrollToTop />
  </div>
</template>

<script>
import EnquirySection from "./EnquirySection.vue";
import NewFooter from "./NewFooter.vue";
import ScrollToTop from "../../components/reusable/ScrollToTop.vue";
import { mapActions } from "vuex";

export default {
  components: {
    EnquirySection,
    NewFooter,
    ScrollToTop,
  },
  methods: {
    ...mapActions(["scrollTop"]),
  },
  mounted() {
    this.scrollTop();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../src/assets/scss/stm.scss";
</style>
